import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createStyles } from '@mantine/styles';
import { addBreakpointMedia, objectDeepMerging, ThemeBreakpoints } from '../../../utils/index.js';
import { MultiSelectRootVariable, RootVariable } from '../constant.js';

var getDefaultStyles = function getDefaultStyles() {
  return {
    root: _defineProperty(_defineProperty({}, MultiSelectRootVariable.MULTI_SELECT_VALUE_COLOR, 'var(--gui-color-text-2)'), MultiSelectRootVariable.MULTI_SELECT_VALUE_BG, 'var(--gui-color-cmpt-11)')
  };
};
var getLgStyles = function getLgStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MultiSelectRootVariable.MULTI_SELECT_INPUT_TRANSFORM_OFFSET, 'translateY(2px)'), MultiSelectRootVariable.MULTI_SELECT_VALUE_HEIGHT, '24px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_SIZE, '12px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_WEIGHT, 500), MultiSelectRootVariable.MULTI_SELECT_VALUE_PADDING, '0 8px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_RADIUS, '4px'), MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, '11px')
  };
};
var getMdStyles = function getMdStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MultiSelectRootVariable.MULTI_SELECT_INPUT_TRANSFORM_OFFSET, 'translateY(2px)'), MultiSelectRootVariable.MULTI_SELECT_VALUE_HEIGHT, '24px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_SIZE, '12px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_WEIGHT, 500), MultiSelectRootVariable.MULTI_SELECT_VALUE_PADDING, '0 8px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_RADIUS, '4px'), MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, '7px')
  };
};
var getSmStyles = function getSmStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MultiSelectRootVariable.MULTI_SELECT_INPUT_TRANSFORM_OFFSET, 'translateY(-1px)'), MultiSelectRootVariable.MULTI_SELECT_VALUE_HEIGHT, '20px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_SIZE, '12px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_WEIGHT, 400), MultiSelectRootVariable.MULTI_SELECT_VALUE_PADDING, '0 8px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_RADIUS, '4px'), MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, '5px')
  };
};
var getXsStyles = function getXsStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MultiSelectRootVariable.MULTI_SELECT_INPUT_TRANSFORM_OFFSET, 'translateY(-1px)'), MultiSelectRootVariable.MULTI_SELECT_VALUE_HEIGHT, '16px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_SIZE, '12px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_WEIGHT, 400), MultiSelectRootVariable.MULTI_SELECT_VALUE_PADDING, '0 4px'), MultiSelectRootVariable.MULTI_SELECT_VALUE_RADIUS, '2px'), MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, '3px')
  };
};
var getCurrentVariantAndSizeStyle = function getCurrentVariantAndSizeStyle(_ref) {
  var size = _ref.size;
  return objectDeepMerging(getDefaultStyles(), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, size === 'lg' ? getLgStyles() : {}), size === 'md' ? getMdStyles() : {}), size === 'sm' ? getSmStyles() : {}), size === 'xs' ? getXsStyles() : {}));
};
var useMultiSelectStyle = createStyles(function (_, _ref2) {
  var size = _ref2.size,
    breakpoints = _ref2.breakpoints;
  return addBreakpointMedia(function () {
    return objectDeepMerging(getCurrentVariantAndSizeStyle({
      size: size
    }), {
      root: {},
      input: {
        height: 'auto !important',
        paddingTop: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, ") !important"),
        paddingBottom: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUES_VERTICAL_PADDING, ") !important")
      },
      rightSection: {},
      rightSectionIcon: {},
      dropdown: {},
      itemsWrapper: {},
      item: {},
      icon: {},
      iconElement: {},
      separator: {},
      separatorLabel: {},
      nothingFound: {},
      wrapper: {},
      invalid: {},
      disabled: {},
      withIcon: {},
      error: {},
      label: {},
      require: {},
      description: {},
      searchInput: {
        minWidth: 0,
        marginLeft: 0,
        lineHeight: 'normal',
        fontFamily: 'inherit',
        boxSizing: 'border-box',
        transform: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_INPUT_TRANSFORM_OFFSET, ")"),
        '&::placeholder': {
          color: "var(".concat(RootVariable.SELECT_PLACEHOLDER_COLOR, ")"),
          fontSize: "var(".concat(RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, ")"),
          fontWeight: "var(".concat(RootVariable.SELECT_PLACEHOLDER_FONT_WEIGHT, ")")
        },
        '&:not(:placeholder-shown)': {
          display: 'none'
        },
        '&[aria-invalid="true"]::placeholder': {
          color: "var(".concat(RootVariable.SELECT_INVALID_PLACEHOLDER_COLOR, ")")
        },
        '&:disabled::placeholder': {
          color: "var(".concat(RootVariable.SELECT_DISABLED_PLACEHOLDER_COLOR, ")")
        }
      },
      value: {
        margin: 0,
        marginRight: '4px',
        display: 'flex',
        alignItems: 'center',
        height: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_HEIGHT, ")"),
        padding: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_PADDING, ")"),
        color: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_COLOR, ")"),
        background: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_BG, ")"),
        fontSize: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_SIZE, ")"),
        fontWeight: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_FONT_WEIGHT, ")"),
        borderRadius: "var(".concat(MultiSelectRootVariable.MULTI_SELECT_VALUE_RADIUS, ")")
      },
      values: {
        rowGap: '4px',
        minHeight: 'auto',
        marginLeft: 0
      },
      defaultValue: {},
      defaultValueRemove: {},
      defaultValueLabel: {}
    });
  }, {}, breakpoints, ThemeBreakpoints);
});

export { useMultiSelectStyle };
//# sourceMappingURL=GateMultiSelect.style.js.map
